var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import AppProvider from '@components/Shared/State/provider';
import SbThemeProvider from '@components/theme/provider';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Layout } from './layout';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { svSE as dataGridsvSE } from '@mui/x-data-grid/locales';
import { svSE as pickerssvSE } from '@mui/x-date-pickers/locales';
import { svSE as coresvSE } from '@mui/material/locale';
const queryClient = new QueryClient();
const locales = ((_a = globalThis.Shopify) === null || _a === void 0 ? void 0 : _a.locale) === 'sv' ? [dataGridsvSE, pickerssvSE, coresvSE] : [];
const theme = createTheme({
    account: {
        navigation: {
            background: 'var(--settings-account-navigation-background-color)',
            text: 'var(--settings-account-navigation-text-color)',
        },
        page: {
            heading: 'var(--settings-account-page-heading-text-color)',
            subHeading: 'var(--settings-account-page-sub-heading-text-color)',
        },
    },
}, ...locales);
export default function LoadOrders(element) {
    return __awaiter(this, void 0, void 0, function* () {
        const rootDom = createRoot(element[0]);
        const menuItems = globalThis.metaobjects.account_menu_items
            .map((item) => (Object.assign(Object.assign({}, item), { url: item.url ? (item.url.endsWith('/account') ? window.Theme.routes.account_url : item.url) : window.Theme.routes.account_url })))
            .sort((a, b) => (a.position || 0) - (b.position || 0));
        rootDom.render(_jsx(AppProvider, { children: _jsx(SbThemeProvider, { children: _jsx(QueryClientProvider, Object.assign({ client: queryClient }, { children: _jsx(BrowserRouter, { children: _jsx(ThemeProvider, Object.assign({ theme: theme }, { children: _jsx(Layout, { menuItems: menuItems }) })) }) })) }) }));
    });
}
